import type { IPossibleActivityPerformer } from '@common/interfaces/serviceWorkflow';
import { UrlBuilder } from '@common/utils/urlBuilder';
import { fetchJson } from '@frontend/store/fetch';

interface IListActivityPerformersQuery {
    excludePractitioners?: boolean;
    includeAbsences?: boolean;
    isRequestRecipient?: boolean;
    organizationIds?: string[];
    serviceActivityIds: string[];
}

export async function listActivityPerformers(
    serviceId: string,
    query: IListActivityPerformersQuery,
    signal: AbortSignal
): Promise<(IPossibleActivityPerformer | Pick<IPossibleActivityPerformer, 'organization'>)[]> {
    const { excludePractitioners, includeAbsences, isRequestRecipient, organizationIds, serviceActivityIds } = query;
    const urlBuilder = new UrlBuilder(`/api/services/${serviceId}/activityPerformers`).add({ serviceActivityIds });

    if (excludePractitioners) {
        urlBuilder.add({ excludePractitioners });
    }

    if (includeAbsences) {
        urlBuilder.add({ includeAbsences });
    }

    if (isRequestRecipient) {
        urlBuilder.add({ isRequestRecipient });
    }

    if (organizationIds?.length) {
        urlBuilder.add({ organizationIds });
    }

    const url = urlBuilder.build();
    const result = await fetchJson({ method: 'GET', signal, url });

    return result?.json?.items;
}
